import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { DIMENSION_LABELS } from "@/lib/scoring";

export default function WheelOfLife({ scores = {}, size = 320 }) {
  const data = Object.entries(DIMENSION_LABELS).map(([id, label]) => ({
    dim: label,
    value: scores[id] == null ? 0 : Number(scores[id]),
    raw: scores[id],
  }));

  return (
    <div className="w-full" style={{ height: size }} data-testid="wheel-of-life">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={data} outerRadius="76%" margin={{ top: 12, right: 24, bottom: 12, left: 24 }}>
          <PolarGrid stroke="#E6E2D8" radialLines={false} />
          <PolarAngleAxis
            dataKey="dim"
            tick={{ fontFamily: "DM Sans, sans-serif", fontSize: 12, fill: "#6B7A75" }}
          />
          <PolarRadiusAxis angle={90} domain={[0, 10]} tick={false} axisLine={false} tickCount={6} />
          <Tooltip
            contentStyle={{
              background: "#fff",
              border: "1px solid #E6E2D8",
              borderRadius: 14,
              fontFamily: "DM Sans, sans-serif",
              boxShadow: "0 8px 24px rgba(44,53,50,0.08)",
            }}
            formatter={(v, _n, item) => {
              const raw = item?.payload?.raw;
              return [raw == null ? "Sin datos" : Number(raw).toFixed(1), item.payload.dim];
            }}
          />
          <Radar
            name="Bienestar"
            dataKey="value"
            stroke="#2A9D8F"
            fill="#2A9D8F"
            fillOpacity={0.22}
            strokeWidth={2}
            dot={{ r: 3, fill: "#2A9D8F", stroke: "#fff", strokeWidth: 1.5 }}
            isAnimationActive
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
